import fetch from "auth/FetchInterceptor";

const powerBiService = {};

powerBiService.getRelatorios = function () {
	return fetch({
		url: "/v1/rest/meus-relatorios",
		method: "get",
	});
};

powerBiService.getParametros = function (id) {
	return fetch({
		url: "/v1/rest/parametros-bi/" + id,
		method: "get",
	});
};

export default powerBiService;
